// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"228a4a34","453":"02337e5c","455":"da16e84c"}[chunkId] + ".chunk.js";
};